import { useState } from 'react';

import { CancelSaveButtons } from '@components/cancel-save-buttons';
import { Card } from '@components/card';
import { FileButton } from '@components/file-button';
import { ImageViewer } from '@components/previewer';
import { ImageViewerProps } from '@components/previewer/image-viewer';
import { Stack } from '@components/stack';
import { Text } from '@components/text';

import { useStore } from 'models/Provider';

type ImageInputProps = ImageViewerProps & {
  onSave(file: File): void;
  saveDisabled?: boolean;
};

export const ImageInput = ({ url, onSave, saveDisabled, ...sizes }: ImageInputProps) => {
  const { t } = useStore();
  const [draft, setDraft] = useState<File | null>(null);

  return (
    <Card variant="transparent" space={6}>
      <Stack orientation="vertical" space={6}>
        <ImageViewer url={draft ? URL.createObjectURL(draft) : url} {...sizes} />
        <Stack space={4} align="flex-end">
          <FileButton
            isReplace={Boolean(url)}
            addText={t('components.imageinput.add')}
            replaceText={t('components.imageinput.replace')}
            onFileSelected={setDraft}
            fileType="image"
          />
          <Text font="regular14" color="purple60" text={t('files.accepted', '.jpg, .png & .gif')} />
        </Stack>
        <CancelSaveButtons
          isOpen={Boolean(draft)}
          onCancel={() => setDraft(null)}
          onSave={() => onSave(draft!)}
          isDisabled={saveDisabled}
        />
      </Stack>
    </Card>
  );
};
